module.exports = __webpack_public_path__ + "img/xingye.f55a4916.png";